'use client'

import { ReactNode, useEffect } from "react"
// import PageLayout from "./_config"
import PageLayout from "@/util/board_config"
import { usePathname, redirect, useRouter, useSearchParams  } from "next/navigation"
import { tabsType } from "@/type/page"


import BoardView from "@/components/board/detail_v2"
import VerifiedView from "./view"
import { mobileModel } from "react-device-detect"
import { setNeedRefresh } from "@/type/historyStack"; 

export interface TabWithParam extends tabsType {
  param: Record<string, any>
}
export default function ClientLayout({ children }: { children: ReactNode }) {
    const pathname = usePathname()
    const basePath = pathname.split("/").slice(0, 3).join("/")
    const router = useRouter();

    
    const perPage = mobileModel ? 10 : 20

    const pageConfig: Record<string, { 
        apiUrlBase: string; 
        responseKey: string; 
        tabs_path: TabWithParam[] 
        ViewComponent: React.ComponentType<any>
        isSearch:boolean;
    }> = {
        "/sportsanalysis/": {
            apiUrlBase: "/api/analysis/",
            responseKey: "posts",
            tabs_path: [
                { name: "스포츠 분석", path: "/sportsanalysis/", param: {page:1 } },
                // { name: "회원분석", path: "/analysis/users/", param: {cate:2, page:1} },
                // { name: "야구선발정보", path: "/analysis/advance/", param: {page:1} },
            ],
            ViewComponent: VerifiedView,
            isSearch: false
        },
        // "/sportsanalysis/users": {
        //     apiUrlBase: "/api/community/",
        //     responseKey: "posts_list",
        //     tabs_path: [
        //         { name: "스포츠 분석", path: "/sportsanalysis/", param: {page:1 } },
        //         { name: "회원분석", path: "/sportsanalysis/users/", param: {cate:2} },
        //         // { name: "야구선발정보", path: "/sportsanalysis/advance/", param: {page:1} },
        //     ],
        //     ViewComponent: BoardView,
        //     isSearch: true
        // },
        // "/sportsanalysis/advance": {
        //     apiUrlBase: "/api/special/select/",
        //     responseKey: "report",
        //     tabs_path: [
        //         { name: "스포츠 분석", path: "/sportsanalysis/", param: {page:1 } },
        //         { name: "회원분석", path: "/sportsanalysis/users/", param: {cate:2} },
        //         { name: "야구선발정보", path: "/sportsanalysis/advance/", param: {page:1} },
        //     ],
        //     ViewComponent: BoardView,
        //     isSearch: false
        // },



    }

    const config = pageConfig[basePath] || { apiUrlBase: "", responseKey: "posts_list", tabs_path: [] }
    const { apiUrlBase, responseKey, tabs_path, ViewComponent, isSearch } = config
    console.log(pageConfig, basePath)

    // useEffect(() => {
    //     if(pathname == "/analysis/"){
    //         setNeedRefresh(true)
    //         router.replace("/sportsanalysis");
    //     }
    // }, [pathname, router])

    return (
        <PageLayout apiUrlBase={apiUrlBase}
                    responseKey={responseKey} 
                    defaultCate={1}
                    tabs_path={tabs_path}
                    editCategories={[2, 3]}
                    ViewComponent={ViewComponent}
                    isSearch={isSearch}
                    perPage={perPage} >
            {children}
        </PageLayout>
    )
}
